import getConfig from "./config";
import {convertToPlainObject} from "./helpers";

const config = getConfig();

// noinspection JSValidateJSDoc
/**
 *
 * @returns {Promise<Fancybox>}
 * @throws {Error}
 */
const getFancybox = async () => {
    await import("@fancyapps/ui/dist/fancybox/fancybox.css");
    const {Fancybox} = await import("@fancyapps/ui");

    if ("function" !== typeof Fancybox) {
        console.error("Failed to load Fancybox");
        return null;
    }

    return Fancybox;
};

const setupFancybox = async () => {
    const els = document.querySelectorAll("[data-fancybox]");
    if (0 === els.length) {
        return;
    }

    await import("@fancyapps/ui/dist/fancybox/fancybox.css");

    const Fancybox = await getFancybox();

    if ("function" !== typeof Fancybox) {
        return;
    }

    /*window.Carousel.defaults.Navigation = {
     ...window.Carousel.defaults.Navigation,
     nextTpl:
     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" tabindex="-1"><defs><style>.cls-1{fill:#fff;stroke:none;}.cls-2{fill:#ab966c;stroke:none;}</style></defs><circle class="cls-2" cx="35" cy="35" r="28.8"/><polygon class="cls-1" points="49.63 35 36.07 27.17 36.07 34.5 6.2 34.5 6.2 35 6.2 35.5 36.07 35.5 36.07 42.83 49.63 35"/></svg>',
     prevTpl:
     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" tabindex="-1"><defs><style>.cls-1{fill:#fff;stroke:none;}.cls-2{fill:#ab966c;stroke:none;}</style></defs><circle class="cls-2" cx="35" cy="35" r="28.8"/><polygon class="cls-1" points="20.37 35 33.93 27.17 33.93 34.5 63.8 34.5 63.8 35 63.8 35.5 33.93 35.5 33.93 42.83 20.37 35"/></svg>',
     };*/

    // noinspection JSUnresolvedReference
    Fancybox.bind(
        "[data-fancybox]:not(.fancybox-html)",
        config.fancyboxOptions.default,
    );
    // noinspection JSUnresolvedReference
    Fancybox.bind(
        "[data-fancybox].fancybox-html",
        config.fancyboxOptions.inlineHtml,
    );
};

// noinspection JSUnusedGlobalSymbols
const showFancybox = async (slides, options = {}) => {
    options = convertToPlainObject(options, config.fancyboxOptions.default);
    const Fancybox = await getFancybox();

    if ("function" !== typeof Fancybox) {
        return;
    }

    // noinspection JSUnresolvedReference
    Fancybox.show(slides, options);
};

export {getFancybox, setupFancybox, showFancybox};
